// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { firstValueFrom } from "rxjs";

import { AccountService } from "@box/common/auth/abstractions/account.service";

// FIXME(https://box.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-org-info",
  templateUrl: "organization-information.component.html",
  standalone: false,
})
export class OrganizationInformationComponent implements OnInit {
  // FIXME(https://box.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() nameOnly = false;
  // FIXME(https://box.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() createOrganization = true;
  // FIXME(https://box.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isProvider = false;
  // FIXME(https://box.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() acceptingSponsorship = false;
  // FIXME(https://box.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formGroup: UntypedFormGroup;
  // FIXME(https://box.atlassian.net/browse/CL-903): Migrate to Signals
  // eslint-disable-next-line @angular-eslint/prefer-output-emitter-ref
  @Output() changedBusinessOwned = new EventEmitter<void>();

  constructor(private accountService: AccountService) {}

  async ngOnInit(): Promise<void> {
    if (this.formGroup?.controls?.billingEmail?.value) {
      return;
    }

    const activeAccount = await firstValueFrom(this.accountService.activeAccount$);

    if (activeAccount?.email) {
      this.formGroup.controls.billingEmail.setValue(activeAccount.email);
    }
  }
}
